import type { GridFilterItem, GridFilterModel } from '@mui/x-data-grid-premium'

export function findFilterItem(
  filterModel: GridFilterModel,
  field: string,
): GridFilterItem | undefined {
  return filterModel.items.find((item) => item.field === field)
}

export function replaceFilterItem(
  filterModel: GridFilterModel,
  field: string,
  item: GridFilterItem | null,
): GridFilterModel {
  return {
    ...filterModel,
    items: [
      ...filterModel.items.filter((existingItem) => existingItem.field !== field),
      ...(item ? [item] : []),
    ],
  }
}

export function replaceMatchingFilterItem(
  filterModel: GridFilterModel,
  predicate: (item: GridFilterItem) => boolean,
  item: GridFilterItem | null,
): GridFilterModel {
  return {
    ...filterModel,
    items: [
      ...filterModel.items.filter((existingItem) => !predicate(existingItem)),
      ...(item ? [item] : []),
    ],
  }
}

export function getFilterValue<T>(
  filterModel: GridFilterModel,
  field: string,
): T | undefined {
  return findFilterItem(filterModel, field)?.value as T | undefined
}
